import { render, staticRenderFns } from "./DlgTrainingDelete.vue?vue&type=template&id=d92b0ada&scoped=true"
import script from "./DlgTrainingDelete.vue?vue&type=script&lang=ts"
export * from "./DlgTrainingDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92b0ada",
  null
  
)

export default component.exports